import React, { useState } from 'react';
import Select from 'react-select';
import SelectUtility from '../../blocks/utils/select-utility/select-utility';
import Ddl from '../../models/common/Ddl';

const config = {
    placeholder: ''
};

const selectStyles = {
    menuPortal: (base: any) => ({
        ...base,
        zIndex: 2000
    }),
    menu: (base: any) => ({
        ...base,
        zIndex: 2000
    })
};

interface Props {
    name: any;
    value?: any;
    autoFocus?: boolean;
    className?: string;
    isClearable?: boolean;
    isDisabled?: boolean;
    isLoading?: boolean;
    isMulti?: boolean;
    isSearchable?: boolean;
    options?: Ddl[];
    placeholder?: string;
    small?: boolean;
    onChange?: (name: any, value: any) => void;
    directionUp?: boolean;
    noResultsText?: string;
}

const PrometSelect = (props: Props) => {
    const [componentClassName, setComponentClassName] = useState(getClassName());

    function handleSelectValue() {
        return SelectUtility.getSelectValue(SelectUtility.getSelectOptions(props.options), props.value) || null;
    }

    function handleOptions() {
        return SelectUtility.getSelectOptions(props.options);
    }

    function onMenuOpen() {
        setComponentClassName(`${getClassName()} open`);
    }

    function onMenuClose() {
        setComponentClassName(getClassName());
    }

    function handleChange(selectedOptions: any) {
        if (!props.onChange) { return; }

        if (!selectedOptions) {
            props.onChange(props.name, undefined);
            return;
        }

        let returnValue: any;

        if (props.isMulti) {
            returnValue = selectedOptions.map((x: any) => x.value);
        } else {
            returnValue = selectedOptions.value;
        }

        props.onChange(props.name, returnValue);
    }

    function getClassName(): string {
        let className = 'promet-select';

        if (props.directionUp) {
            if (props.small) className += ' smallInverted';
        }
        else {
            if (props.small) className += ' small';
        }

        if (props.className) className += ` ${props.className}`;

        return className;
    }

    function getNoOptionsMessage(): string {
        return props.noResultsText || "Nema rezultata";
    }

    const { value, onChange, options, className, ...childrenProps } = props;

    return (
        <Select
            className={componentClassName}
            classNamePrefix='dropdown'
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
            placeholder={config.placeholder}
            noOptionsMessage={getNoOptionsMessage}
            value={handleSelectValue()}
            options={handleOptions()}
            onChange={handleChange}
            isClearable
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={selectStyles}
            {...childrenProps}
        />
    );
}

export default PrometSelect;
